export const M2_UNIT_15 = {
  id: "m2-u15",
  title: "Unit 15: Countable vs Uncountable",
  topic: "Food Quantities",
  iconType: "shopping", // Mantenemos el icono de comida/compras
  grammarImage: "/m2-u15-grammar.jpg", // Sube esta imagen a public
  grammarText: "Algunas cosas se pueden contar (Apples) y otras no (Water, Rice). Usamos 'Some' para oraciones afirmativas y 'Any' para preguntas y negaciones.",
  sets: [
    {
      id: "u31-set1",
      title: "Set 1: Countable vs Uncountable - Basic",
      questions: [
        { type: "mc", q: "One apple. Two ___", options: ["apples", "apple"], a: "apples" },
        { type: "mc", q: "Water? One water? No!", options: ["True - uncountable", "False"], a: "True - uncountable" },
        { type: "blank", q: "Sugar = ___ (uncountable).", options: ["uncountable"], a: "uncountable" },
        { type: "mc", q: "Two ___ bread. (slices/loaves)", options: ["slices", "breads"], a: "slices" },
        { type: "blank", q: "Rice = ___ (uncountable).", options: ["uncountable"], a: "uncountable" },
        { type: "order", q: "Ordena: countable foods", words: ["apples", "eggs", "bottles"], a: "apples, eggs, bottles" },
        { type: "mc", q: "'Two rices' wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Milk = uncountable. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Flour = ___ (uncountable).", options: ["uncountable"], a: "uncountable" },
        { type: "order", q: "Ordena: uncountable foods", words: ["water", "sugar", "rice"], a: "water, sugar, rice" }
      ]
    },
    {
      id: "u31-set2",
      title: "Set 2: Food Containers Review",
      questions: [
        { type: "mc", q: "Liquid: bottle, can, ___", options: ["carton", "bag"], a: "carton" },
        { type: "mc", q: "Bread: loaf, slice, ___", options: ["bag", "jar"], a: "bag" },
        { type: "blank", q: "Jam: ___ (jar).", options: ["jar"], a: "jar" },
        { type: "mc", q: "Countable containers: bottle, slice, pack.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Milk: ___ carton.", options: ["a"], a: "a" },
        { type: "order", q: "Ordena: pack of sugar", words: ["pack", "of", "sugar"], a: "pack of sugar" },
        { type: "mc", "q": "Two loaves bread. Correct?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Jar of jam. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Bag of ___ (rice).", options: ["rice"], a: "rice" },
        { type: "order", q: "Ordena: slice of bread", words: ["slice", "of", "bread"], a: "slice of bread" }
      ]
    },
    {
      id: "u31-set3",
      title: "Set 3: Some/Any Practice",
      questions: [
        { type: "mc", q: "I have ___ apples. (3-4)", options: ["some", "any"], a: "some" },
        { type: "mc", q: "Do you have ___ apples?", options: ["any", "some"], a: "any" },
        { type: "blank", q: "There are ___ eggs. (some)", options: ["some"], a: "some" },
        { type: "mc", q: "Questions: any. Statements: ___", options: ["some", "a"], a: "some" },
        { type: "blank", q: "Do you need ___ milk? (any)", options: ["any"], a: "any" },
        { type: "order", q: "Ordena: some apples", words: ["some", "apples"], a: "some apples" },
        { type: "mc", q: "'Some milk' statement correct. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Any eggs? Question form.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "I have ___ rice. (some)", options: ["some"], a: "some" },
        { type: "order", q: "Ordena: any sugar?", words: ["any", "sugar?"], a: "any sugar?" }
      ]
    },
    {
      id: "u31-set4",
      title: "Set 4: Talking About Food",
      questions: [
        { type: "mc", q: "I like ___ apples.", options: ["some", "any"], a: "some" },
        { type: "mc", q: "Do you like ___ rice?", options: ["any", "some"], a: "any" },
        { type: "blank", q: "There is ___ bread. (some)", options: ["some"], a: "some" },
        { type: "mc", q: "We need ___ milk.", options: ["some", "any"], a: "some" },
        { type: "blank", q: "___ sugar for coffee? (Any)", options: ["Any"], a: "Any" },
        { type: "order", q: "Ordena: some fruit", words: ["some", "fruit"], a: "some fruit" },
        { type: "mc", "q": "'Any apples?' = question. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "I have ___ eggs. (6)", options: ["some", "any"], a: "some" },
        { type: "blank", q: "Do you have ___ water? (any)", options: ["any"], a: "any" },
        { type: "order", q: "Ordena: some milk", words: ["some", "milk"], a: "some milk" }
      ]
    },
    {
      id: "u31-set5",
      title: "Set 5: Shopping Dialogue",
      questions: [
        { type: "mc", q: "Do you have ___ apples?", options: ["any", "some"], a: "any" },
        { type: "blank", q: "Yes, we have ___ apples. (some)", options: ["some"], a: "some" },
        { type: "mc", "q": "How about ___ bread?", options: ["any", "some"], a: "any" },
        { type: "blank", q: "We have ___ bread. (some)", options: ["some"], a: "some" },
        { type: "mc", "q": "___ milk?", options: ["Any", "Some"], a: "Any" },
        { type: "order", q: "Ordena: Do you have any milk?", words: ["Do", "you", "have", "any", "milk?"], a: "Do you have any milk?" },
        { type: "mc", "q": "Yes, ___ milk. (some)", options: ["some", "any"], a: "some" },
        { type: "blank", "q": "___ rice? (Any)", options: ["Any"], a: "Any" },
        { type: "mc", "q": "No, we don't have ___ rice.", options: ["any", "some"], a: "any" },
        { type: "order", q: "Ordena: Some bread, please.", words: ["Some", "bread,", "please."], a: "Some bread, please." }
      ]
    },
    {
      id: "u31-set6",
      title: "Set 6: Error Correction",
      questions: [
        { type: "mc", "q": "I have two apple. (Fix)", options: ["two apples", "two apple"], a: "two apples" },
        { type: "blank", "q": "Much water? No, one water. → ___ water.", options: ["some"], a: "some" },
        { type: "mc", "q": "Two breads wrong. True?", options: ["True", "False"], a: "True" },
        { type: "order", "q": "Corrige: any apples (statement)", words: ["some"], a: "some" },
        { type: "blank", "q": "Do you have some milk? → Do you have ___ milk?", options: ["any"], a: "any" },
        { type: "mc", "q": "'Some rices' wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "One sugar? Wrong uncountable.", options: ["True"], a: "True" },
        { type: "blank", "q": "Two slice bread. → Two ___ of bread.", options: ["slices"], a: "slices" },
        { type: "order", "q": "Corrige: I need some water (question)", words: ["any"], a: "any" },
        { type: "mc", "q": "Bag of rice correct. True?", options: ["True", "False"], "a": "True" }
      ]
    },
    {
      id: "u31-set7",
      title: "Set 7: Recipe Practice",
      questions: [
        { type: "mc", "q": "2 ___ flour. (cups)", options: ["cups of", "cup of"], a: "cups of" },
        { type: "blank", "q": "3 ___ sugar. (spoons)", options: ["spoons"], a: "spoons" },
        { type: "mc", "q": "1 liter water + 2 carrots. Correct?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "500g ___ (cheese).", options: ["cheese"], a: "cheese" },
        { type: "mc", "q": "Some salt, any pepper? Question form.", options: ["True"], a: "True" },
        { type: "order", "q": "Ordena: recipe ingredients", words: ["2", "cups", "flour,", "1", "liter", "milk"], a: "2 cups flour, 1 liter milk" },
        { type: "mc", "q": "Pack of pasta correct. True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "Jar of ___ sauce.", options: ["tomato"], a: "tomato" },
        { type: "mc", "q": "2 eggs (countable). True?", options: ["True", "False"], a: "True" },
        { type: "order", "q": "Ordena: some oil", words: ["some", "oil"], a: "some oil" }
      ]
    },
    {
      id: "u31-set8",
      title: "Set 8: Shopping List Comprehension",
      questions: [
        { type: "mc", "q": "2 loaves bread = countable. True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "1 ___ milk. (liter)", options: ["liter"], a: "liter" },
        { type: "mc", "q": "500g cheese correct quantity.", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "___ apples. (bag of)", options: ["Bag of"], a: "Bag of" },
        { type: "mc", "q": "Can tuna, jar jam. True?", options: ["True", "False"], a: "True" },
        { type: "order", "q": "Lista: bread, milk, eggs, butter.", words: ["loaf", "liter", "dozen", "pack"], a: "loaf, liter, dozen, pack" },
        { type: "mc", "q": "Bag rice correct. True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "2 ___ bread. (loaves)", options: ["loaves"], a: "loaves" },
        { type: "mc", "q": "Some eggs, any milk? Correct forms.", options: ["True"], a: "True" },
        { type: "order", "q": "Complete list: apples, bread, milk, cheese.", words: ["bag", "loaf", "liter", "500g"], a: "bag, loaf, liter, 500g" }
      ]
    },
    {
      id: "u31-set9",
      title: "Set 9: Advanced Some/Any",
      questions: [
        // Convertido a MC para soportar 2 respuestas
        { type: "mc", "q": "I have ___ apples. Do you have ___ apples?", options: ["some / any", "any / some"], a: "some / any" },
        { type: "mc", "q": "Recipe: some flour, any eggs?", options: ["some flour, any eggs", "any flour, some eggs"], a: "some flour, any eggs" },
        // Convertido a MC
        { type: "mc", "q": "Store: We have ___ milk. Do you need ___ milk?", options: ["some / any", "any / some"], a: "some / any" },
        { type: "mc", "q": "Questions always any. Statements usually some.", options: ["True"], a: "True" },
        // Convertido a MC
        { type: "mc", "q": "___ sugar? Yes, we have ___ sugar.", options: ["Any / some", "Some / any"], a: "Any / some" },
        { type: "order", "q": "Ordena: some rice / any rice?", words: ["some", "rice", "any", "rice?"], a: "some rice, any rice?" },
        { type: "mc", "q": "No rice = no any rice. Correct?", options: ["True"], a: "True" },
        // Convertido a MC
        { type: "mc", "q": "I need ___ bread. Shop has ___ bread.", options: ["some / some", "any / any"], a: "some / some" },
        { type: "mc", "q": "Offer: Would you like some tea?", options: ["True - some"], a: "True - some" },
        { type: "order", "q": "Mix: some/any in dialogue", words: ["Do", "you", "have", "any", "eggs?", "Yes,", "some", "eggs."], a: "Do you have any eggs? Yes, some eggs." }
      ]
    },
    {
      id: "u31-set10",
      title: "Set 10: Full Food Grammar Challenge",
      questions: [
        { type: "mc", "q": "Countable: apples/uncountable: sugar/some-any correct. All?", options: ["True"], a: "True" },
        // Convertido a MC para soportar 3 respuestas
        { type: "mc", "q": "Recipe: 2 cups ___ + some ___ + any ___? (flour/eggs/salt)", options: ["flour / eggs / salt", "eggs / flour / salt"], a: "flour / eggs / salt" },
        { type: "order", "q": "Master shopping: loaves bread, cartons milk, bags rice, jars jam.", words: ["loaves", "of", "bread,", "cartons", "of", "milk,", "bags", "of", "rice"], a: "loaves of bread, cartons of milk, bags of rice" },
        { type: "mc", "q": "Quick: Do you have ___ water? (any)", options: ["True"], a: "True" },
        // Convertido a MC para soportar 3 respuestas
        { type: "mc", "q": "Store dialogue: Any ___, Some ___, Any ___ (apples/bread/milk).", options: ["apples / bread / milk", "bread / apples / milk"], a: "apples / bread / milk" },
        { type: "mc", "q": "'Two milks' wrong uncountable. True?", options: ["True"], a: "True" },
        { type: "order", "q": "Challenge: complete recipe + shopping.", words: ["2", "cups", "flour", "(uncountable)", "6", "eggs", "(countable)", "some", "salt"], a: "2 cups flour (uncountable), 6 eggs (countable), some salt" },
        // Convertido a MC
        { type: "mc", "q": "Containers: loaf, jar, bag (bread/jam/rice).", options: ["bread / jam / rice", "jam / rice / bread"], a: "bread / jam / rice" },
        { type: "mc", "q": "All grammar: some statements/any questions. True?", options: ["True"], a: "True" },
        { type: "order", "q": "Ultimate: full market scene.", words: ["Do", "you", "have", "any", "apples?", "Yes,", "some", "apples.", "How", "about", "bread?", "Loaf", "of", "bread?"], a: "Do you have any apples? Yes, some apples. How about bread? Loaf of bread?" }
      ]
    }
  ]
};
